import React, { useEffect, useState } from 'react';
import OpReqsPopovers from './OpReqsPopovers';
import {
  PeopleCommitteeIcon,
  PlusIcon,
  ProgressBarIcon,
} from '../../services/SvgLibrary';
import styles from '../../styles/calendar/Calendar.module.scss';
import { legDivisionRoles, superAdminRoles } from '../../services/constants';
import CheckboxMenu from '../library/CheckboxMenu';
import { create } from 'framer-motion/client';

const OperReqsFilters = ({
  committees,
  displayCommittee,
  setDisplayCommittee,
  preset,
  toggleCommittee,
  togglePreset,
  checkAllCommittees,
  onCheckOrUncheckAllCheckbox,
  statuses,
  toggleStatus,
  displayReports,
  displayMilestones,
  userRole,
  addReportPermission,
  setDisplayMilestones,
  setDisplayReports,
  changeReportTrackingDisplay,
  changeReportTrackingPopupWindow,
}) => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  useEffect(() => {
    setScreenWidth(window.innerWidth);
  }, [window.innerWidth]);
  return (
    <>
      <div>
        <button
          className={`btn  ${styles['dropdown-filter-toggle']}`}
          onClick={() => {
            setDisplayCommittee(!displayCommittee);
          }}
          id='PopoverMenu'
          type='button'>
          <PeopleCommitteeIcon width='20' height='20' classNameProp='pe-1' />
          {screenWidth > 1070 && (
            <>
              Committees
              <span
                className='badge'
                style={{ color: '#002164', backgroundColor: '#c0d1f3' }}>
                {committees.filter(com => com.show).length}
              </span>
            </>
          )}
        </button>
        {displayCommittee && (
          <CheckboxMenu
            componentType='popover'
            checkboxes={committees}
            columnNumber={3}
            preset={preset}
            toggleCheckbox={toggleCommittee}
            togglePreset={togglePreset}
            checkAll={checkAllCommittees}
            isOpen={displayCommittee}
            toggleCheckboxMenu={() => setDisplayCommittee(!displayCommittee)}
            toggleAllCheckboxes={onCheckOrUncheckAllCheckbox}
            params='committee_name'
            presetNameBase='opReq-committee'
          />
        )}
        <button
          className={`btn ${screenWidth > 1070 && `dropdown-toggle`} ${
            styles['dropdown-filter-toggle']
          }`}
          id='PopoverCheckbox'
          type='button'>
          <div style={{ position: 'relative', display: 'inline-block' }}>
            <ProgressBarIcon classNameProp='pe-1' />
          </div>
          {screenWidth > 1070 && (
            <>
              Status
              <span
                className='badge'
                style={{ color: '#002164', backgroundColor: '#c0d1f3' }}>
                {Object.values(statuses).filter(status => status).length}
              </span>
            </>
          )}
        </button>

        {addReportPermission && (
          <button
            className={`btn ${
              [
                ...superAdminRoles,
                ...legDivisionRoles,
                'Finance Attorney',
                'Land Use Attorney',
              ].includes(userRole)
                ? `${styles['create-report-button']}`
                : `${styles['non-leg-staff']} ${styles['create-report-button']}`
            }`}
            onClick={() => {
              changeReportTrackingDisplay('create');
              changeReportTrackingPopupWindow(true);
            }}>
            <PlusIcon width='14' height='14' /> New
          </button>
        )}
      </div>
      <OpReqsPopovers
        toggleStatus={toggleStatus}
        statuses={statuses}
        displayMilestones={displayMilestones}
        displayReports={displayReports}
        setDisplayMilestones={setDisplayMilestones}
        setDisplayReports={setDisplayReports}
      />
    </>
  );
};

export default OperReqsFilters;
